import { render, staticRenderFns } from "./Scheda.vue?vue&type=template&id=e5515512&"
import script from "./Scheda.vue?vue&type=script&lang=js&"
export * from "./Scheda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports